


















































































import { expendItemDetailApi } from "@/api/order";
import { solveLargeNumber } from "@/utils/common";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() originData!: any;
  itemDetail: any = {
    // 转课订单数据
    unit_price: 0,
  };
  refundNumber: number = 0; // 转课课时
  get refundAmount() {
    // 转课金额
    if (
      Number(this.itemDetail.unit_price) * Number(this.refundNumber) >
      Number(this.itemDetail.usable_amount)
    ) {
      return solveLargeNumber(this.itemDetail.usable_amount);
    } else {
      return Math.ceil(
        (solveLargeNumber(this.itemDetail.unit_price) *
          solveLargeNumber(this.refundNumber)) /
          100
      );
    }
  }
  handlingFee: number = 0; // 手续费
  refundResult: number = 0; // 应退金额
  created() {
    const iid = Number(this.$route.query.iid);
    const sid = Number(this.$route.query.sid);
    if (iid && sid) {
      expendItemDetailApi({
        item_ids: [iid],
        student_id: sid,
      }).then((res: any) => {
        const data = res.data.list[0];
        this.itemDetail = {
          item_id: data.item_id,
          course_id: data.product_id,
          product_name: data.product_name,
          order_no: data.order_no,
          spec_name: data.spec_name,
          quantity: data.quantity,
          give_product_quantity: data.give_product_quantity,
          receivable_amount: data.receivable_amount,
          consume_number: data.item_course.consume_number,
          usable_amount: data.item_course.usable_amount,
          usable_number: data.item_course.usable_number,
          unit_price: data.unit_price,
        };
        this.refundNumber = this.itemDetail.usable_number;
        this.refundResult = this.itemDetail.usable_number;
        this.handleSum();
        this.handleEmit();
        this.$emit("change", data);
      });
    }
  }
  handleRefundNumberChange(v: string) {
    const n = Number(Number(v).toFixed(2));
    if (n < 0) {
      this.refundNumber = 0;
    } else if (n > Number(this.itemDetail.usable_number)) {
      this.$message({
        type: "warning",
        message: "转课课时不可大于可转课时",
      });
      this.refundNumber = 0;
      return false;
    } else {
      this.refundNumber = n;
    }
    this.handlingFee = 0;
    this.handleSum();
  }
  handleHandlingFeeChange(v: string) {
    const n = Number(Number(v).toFixed(2));
    if (n < 0) {
      this.handlingFee = 0;
    } else if (n > this.refundAmount / 100) {
      this.$message({
        type: "warning",
        message: "手续费不可大于转课金额",
      });
      this.handlingFee = 0;
      return false;
    } else {
      this.handlingFee = n;
    }
    this.handleSum();
  }
  handleSum() {
    const number = solveLargeNumber(this.refundNumber);
    const unit = solveLargeNumber(this.itemDetail.unit_price);
    const fee = solveLargeNumber(this.handlingFee);
    const usable = solveLargeNumber(this.itemDetail.usable_amount);
    if (
      Number(this.itemDetail.unit_price) * Number(this.refundNumber) >
      Number(this.itemDetail.usable_amount)
    ) {
      this.refundResult = (usable - fee) / 100;
    } else {
      this.refundResult = Math.ceil((number * unit - fee * 100) / 100) / 100;
    }
    this.handleEmit();
  }
  handleEmit() {
    this.$emit("update:originData", {
      shouldRefund: this.refundResult,
      refundNumber: this.refundNumber,
      handlingFee: this.handlingFee,
      refundAmount: this.refundAmount,
      ...this.itemDetail,
    });
  }
}
